module.exports = __webpack_public_path__ + "img/play-icon.svg.10954184.webp";